import type { InputInteractiveProps } from './InputInteractive.types';

export const inputInteractiveDefaults: InputInteractiveProps = {
  text: '',
  isDisabled: false,
  isVisible: true,
};
